import * as Yup from "yup";

export const AddSourceValidationSchema = Yup.object().shape({
    name: Yup.string()
    .required("Name is required")
});




